import { PayrollInputDTO, PayrollInputSTO } from "src/models/payroll-inputs";
import { BaseApiService } from "../base";

export class ClientManagerPayrollInputsApiService extends BaseApiService<PayrollInputDTO, PayrollInputSTO> {
  constructor() {
    super({
      servicePath: "/PayrollInputs",
      loadItemsPath: "/GetClientManagerPayrollInputs",
      saveItemsPath: "/SaveClientManagerPayrollInputs",
    });
  }
}
